import { Nullable, Observer, PointerEventTypes, PointerInfo, Scene } from '@babylonjs/core';

export default class RenderingStateTracker {
  private isFullSpeed: boolean;
  private window: Window | undefined | null;
  private document: Document | undefined | null;
  private canvas: HTMLCanvasElement | undefined | null;
  private scene: Scene | undefined | null;
  private pointerObserver: Nullable<Observer<PointerInfo>> | undefined;
  private checkCanvas: Nullable<NodeJS.Timer> | undefined;

  constructor() {
    this.isFullSpeed = true;
    this.clear();
  }

  clear() {
    if (this.scene) {
      if (this.pointerObserver) this.scene.onPointerObservable.remove(this.pointerObserver);
      this.scene = undefined;
    }
    if (this.checkCanvas) clearInterval(this.checkCanvas);
    this.window = undefined;
    this.document = undefined;
    this.canvas = undefined;
  }

  initialize(scene: Scene) {
    if (this.scene) this.clear();
    this.scene = scene;

    const setupListeners = () => {
      if (!this.scene) return;
      this.pointerObserver = this.scene.onPointerObservable.add((pointerInfo: PointerInfo) => {
        switch (pointerInfo.type) {
          case PointerEventTypes.POINTERDOWN:
            this.handleFocusChange(true);
            break;
        }
      });

      this.document?.addEventListener('visibilitychange', () => {
        const isVisible = this.document?.visibilityState === 'visible';
        this.handleVisibilityChange(isVisible);
      });

      this.window?.addEventListener('focus', () => {
        this.handleFocusChange(true);
      });

      this.window?.addEventListener('blur', () => {
        this.handleFocusChange(false);
      });
    };

    this.checkCanvas = setInterval(() => {
      this.window = scene.getEngine().getHostWindow();
      this.document = scene.getEngine().getRenderingCanvas()?.ownerDocument;
      this.canvas = scene.getEngine().getRenderingCanvas();

      if (this.window && this.document && this.canvas) {
        if (this.checkCanvas) clearInterval(this.checkCanvas);
        setupListeners();
      }
    }, 1000);
  }

  handleVisibilityChange(isVisible: boolean) {
    if (isVisible) {
      this.isFullSpeed = true;
    } else {
      this.isFullSpeed = false;
    }
  }

  handleFocusChange(hasFocus: boolean) {
    if (hasFocus) {
      this.isFullSpeed = true;
    } else {
      this.isFullSpeed = false;
    }
  }

  isRenderingAtFullSpeed() {
    return this.isFullSpeed;
  }
}
